<!-- Toast.svelte -->
<!--Copy right - © 2024 tecera gmbh-->
<script>
    import { onDestroy } from "svelte";
    import { fade } from "svelte/transition";
    import { toast_message,toast_message_error } from "../stores.js";

    export let duration = 3000;

    let show = false,show_error=false;
    let timeout_id,timeout_id_error;

    // Show the toast when the message changes
    $: if ($toast_message) {
    show = true;

    clearTimeout(timeout_id); // Clear the previous timeout

    timeout_id = setTimeout(() => {
        show = false;
        $toast_message = "";
    }, duration);
}

$: if ($toast_message_error) {
    show_error = true;

    clearTimeout(timeout_id_error); // Clear the previous timeout

    timeout_id_error = setTimeout(() => {
        show_error = false;
        $toast_message_error = "";
    }, duration);
}

    // Clean up when the component is destroyed
    onDestroy(() => {
        clearTimeout();
    });
</script>

{#if show}
    <div class="toast toast_display show" data-delay="3000" transition:fade>
        <div class="toast-body">
            <strong><i class="fa fa-check"></i>{$toast_message}</strong>
        </div>
    </div>
{/if}

{#if show_error && !show}
    <div class="toast toast_display show" data-delay="3000" transition:fade style="background:#DF4A4A;"> 
        <div class="toast-body">
            <strong><i class="fa-solid fa-triangle-exclamation"></i>{$toast_message_error}</strong>
        </div>
    </div>
{/if}
